/**
 * Mock data for development and testing
 */

import { Brand } from '../types';

export const mockBrands: Brand[] = [
  {
    id: '6233f394-9e10-4cc0-889e-c5fd08263d88',
    name: 'Kiğılı',
    website: 'https://www.kigili.com',
    xmlFeedUrl: 'https://www.kigili.com/products.xml',
    apiKey: 'fc_kigili_test_key_123',
    isActive: true,
    allowedDomains: ['kigili.com', 'www.kigili.com'],
    totalProducts: 156,
    totalMappings: 12,
    createdAt: new Date('2024-01-01').toISOString(),
    updatedAt: new Date('2024-10-10').toISOString(),
  },
  {
    id: '7344g505-0f21-5dd1-990f-d6ge19374d99',
    name: 'Mavi',
    website: 'https://www.mavi.com',
    xmlFeedUrl: 'https://www.mavi.com/feed/products.xml',
    apiKey: 'fc_mavi_test_key_456',
    isActive: true,
    allowedDomains: ['mavi.com', 'www.mavi.com'],
    totalProducts: 234,
    totalMappings: 18,
    createdAt: new Date('2024-01-15').toISOString(),
    updatedAt: new Date('2024-10-09').toISOString(),
  },
  {
    id: '8455h616-1g32-6ee2-aa1g-e7hf20485e00',
    name: 'LC Waikiki',
    website: 'https://www.lcwaikiki.com',
    xmlFeedUrl: 'https://www.lcwaikiki.com/api/products.xml',
    apiKey: 'fc_lcw_test_key_789',
    isActive: false,
    allowedDomains: ['lcwaikiki.com', 'www.lcwaikiki.com'],
    totalProducts: 512,
    totalMappings: 24,
    createdAt: new Date('2024-02-01').toISOString(),
    updatedAt: new Date('2024-09-20').toISOString(),
  },
];

